import {
  Box,
  BoxProps,
  IconButton,
  Link,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import PhoneIcon from "@icons/myicons/phone.svg?react";
import { useFeatureFlag } from "@hooks";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(1),
}));

const IconContainer = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  color: theme.palette.primary.main,
}));

export const PhoneSupportLink = ({
  variant = "default",
  dataTestId = "contact-phone",
  phone = "030 - 7153 3009",
  ...rest
}: {
  variant?: "default" | "compact" | "extended";
  phone?: string;
  dataTestId?: string;
} & BoxProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isPhoneSupportEnabled = useFeatureFlag("PHONE_SUPPORT");

  if (isPhoneSupportEnabled) {
    switch (variant) {
      case "compact":
        return (
          <StyledIconButton data-testid={dataTestId}>
            <Link href={`tel:${phone}`}>
              <Box display="flex">
                <PhoneIcon
                  color={theme.palette.primary.main}
                  width={24}
                  height={24}
                />
              </Box>
            </Link>
          </StyledIconButton>
        );
      case "extended":
        return (
          <Box
            display="flex"
            gap={3}
            alignItems="center"
            textAlign="left"
            {...rest}
          >
            <IconContainer>
              <PhoneIcon />
            </IconContainer>
            <Box>
              <Link href={`tel:${phone}`} data-testid={dataTestId}>
                <Typography variant="body3">{phone}</Typography>
              </Link>
              <Typography variant="caption" color="textSecondary">
                {t("aboutCompany.support.phoneInfo")}
              </Typography>
            </Box>
          </Box>
        );
      default:
        return (
          <Link href={`tel:${phone}`} data-testid={dataTestId}>
            <Typography variant="body3">{phone}</Typography>
          </Link>
        );
    }
  }

  return null;
};
